import { Link } from 'react-router-dom';
import GallerySection from '../components/GallerySection';

export default function Erhverv() {
  // Optimeret billede til erhvervssiden
  const erhvervImg = 'https://assets.auxodev.dk/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/20260630-183706701-ios_1.jpg';
  const optimizedImg = erhvervImg.replace('assets.auxodev.dk/assets/', 'assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/');

  return (
    <>
      {/* React 19 Native Metadata Hoisting */}
      <title>Erhvervs Vinduespolering - Nygaards Vinduespolering</title>
      <meta
        name="description"
        content="Professionel erhvervs vinduespolering til butikker, kontorer, klinikker, ejendomme og virksomheder i Kerteminde og omegn."
      />

      {/* Hero Header */}
      <section className="bg-slate-50/70 py-20 border-b border-slate-100">
        <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
            Erhvervsservice
          </span>
          <h1 className="mt-3 font-display text-3xl font-bold uppercase tracking-wider text-brand-blue sm:text-4xl">
            Erhvervs Vinduespolering
          </h1>
          <div className="mx-auto mt-4 h-0.5 w-12 bg-brand-orange" />
          <p className="mx-auto mt-6 max-w-2xl text-sm font-light leading-relaxed text-slate-500">
            Professionel vinduespolering, der sikrer et præsentabelt og indbydende førstehåndsindtryk af din virksomhed.
          </p>
        </div>
      </section>

      {/* Detaljeret Indhold */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">
            {/* Tekst */}
            <div className="lg:col-span-7">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                Førstehåndsindtrykket
              </span>
              <h2 className="mt-2 font-display text-2xl font-bold uppercase tracking-wider text-brand-dark">
                Et professionelt førstehåndsindtryk
              </h2>
              <p className="mt-6 text-sm font-light leading-relaxed text-slate-500">
                For virksomheder, butikker og klinikker er facaden og vinduerne det første, kunder og samarbejdspartnere møder. Rene og velpudsede ruder signalerer professionalisme, orden og kvalitet. Hos Nygaards Vinduespolering leverer vi en pålidelig erhvervsservice, der er skræddersyet til jeres behov.
              </p>
              <p className="mt-4 text-sm font-light leading-relaxed text-slate-500">
                Vi tilbyder vinduespolering af alle typer erhvervsbygninger, herunder:
              </p>
              <ul className="mt-4 grid grid-cols-1 gap-3 text-xs font-light text-slate-500 sm:grid-cols-2">
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Butikker & detailhandel</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Kontorer & administrationsbygninger</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Klinikker & liberale erhverv</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Erhvervsejendomme & boligforeninger</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Facader med store glaspartier</span>
                </li>
              </ul>

              <div className="mt-8 flex flex-wrap gap-4">
                <Link
                  to="/kontakt"
                  className="rounded-full bg-brand-blue px-8 py-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-white hover:bg-brand-orange transition-all duration-300 hover:scale-105"
                >
                  Få et tilbud på erhvervs vinduespolering
                </Link>
              </div>
            </div>

            {/* Billede */}
            <div className="lg:col-span-5">
              <div className="relative aspect-4/3 overflow-hidden rounded-none bg-slate-100 shadow-none">
                <img
                  src={optimizedImg}
                  alt="Professionel erhvervs vinduespolering i Kerteminde"
                  className="h-full w-full object-cover rounded-none"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Metoder Sektion */}
      <section className="bg-slate-50/50 py-16 border-t border-slate-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
              Fleksible metoder
            </span>
            <h2 className="mt-2 font-display text-2xl font-bold uppercase tracking-wider text-brand-blue">
              Rentvandsanlæg eller traditionel polering?
            </h2>
            <div className="mx-auto mt-4 h-0.5 w-12 bg-brand-orange" />
            <p className="mt-4 text-sm font-light leading-relaxed text-slate-500">
              Vi tilpasser os jeres ejendom og præferencer. Hos Nygaards Vinduespolering tilbyder vi både moderne rentvandsanlæg og traditionel vinduespolering. I vælger selv den metode, der passer bedst til jeres erhvervsbygning.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Rentvandsanlæg */}
            <div className="bg-white p-8 border border-slate-100 shadow-sm flex flex-col justify-between">
              <div>
                <div className="flex h-12 w-12 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue mb-6">
                  <i className="fa-solid fa-droplet text-lg" />
                </div>
                <h3 className="font-display text-base font-bold uppercase tracking-wider text-brand-dark">
                  Rentvandsanlæg (Vask med ultra-rent vand)
                </h3>
                <p className="mt-4 text-xs font-light leading-relaxed text-slate-500">
                  Vores rentvandsanlæg renser vandet for kalk, mineraler og urenheder. Når vi vasker jeres ruder med dette ultra-rene vand, efterlader det en stribefri overflade helt uden brug af kemikalier eller sæbe.
                </p>
                <ul className="mt-4 space-y-2 text-xs font-light text-slate-500">
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-brand-blue" />
                    <span>100% miljøvenligt og kemifrit</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-brand-blue" />
                    <span>Perfekt til store glasfacader og vinduer i højden</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-brand-blue" />
                    <span>Rammer og karme vaskes altid med i prisen</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Traditionel polering */}
            <div className="bg-white p-8 border border-slate-100 shadow-sm flex flex-col justify-between">
              <div>
                <div className="flex h-12 w-12 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue mb-6">
                  <i className="fa-solid fa-hand-sparkles text-lg" />
                </div>
                <h3 className="font-display text-base font-bold uppercase tracking-wider text-brand-dark">
                  Almindelig vinduespolering (Klassisk håndværk)
                </h3>
                <p className="mt-4 text-xs font-light leading-relaxed text-slate-500">
                  Den klassiske metode med professionel indsæbning, skraber og tørring med mikrofiberklud. Dette er det traditionelle håndværk, der sikrer et fuldstændig fejlfrit og krystalklart resultat.
                </p>
                <ul className="mt-4 space-y-2 text-xs font-light text-slate-500">
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-brand-blue" />
                    <span>Klassisk, krystalklar glans</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-brand-blue" />
                    <span>Ideelt til både indvendig og udvendig pudsning</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-brand-blue" />
                    <span>Nænsom og præcis pudsning i detaljer</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fokusområder */}
      <section className="bg-slate-50/70 py-20 border-t border-b border-slate-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
              Vores fokus
            </span>
            <h2 className="mt-2 font-display text-2xl font-bold uppercase tracking-wider text-brand-blue">
              Hvorfor vælge os til jeres erhvervsejendom?
            </h2>
            <div className="mx-auto mt-4 h-0.5 w-12 bg-brand-orange" />
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            <div className="rounded-none border border-slate-200 bg-white p-8 shadow-none">
              <div className="flex h-10 w-10 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue">
                <i className="fa-solid fa-calendar-check" />
              </div>
              <h3 className="mt-6 font-display text-base font-bold uppercase tracking-wider text-brand-dark">Faste aftaler</h3>
              <p className="mt-3 text-xs font-light leading-relaxed text-slate-500">
                Vi tilbyder faste serviceaftaler (f.eks. hver 4. eller 8. uge), så I aldrig skal tænke på, hvornår vinduerne skal pudses næste gang.
              </p>
            </div>
            <div className="rounded-none border border-slate-200 bg-white p-8 shadow-none">
              <div className="flex h-10 w-10 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue">
                <i className="fa-solid fa-clock" />
              </div>
              <h3 className="mt-6 font-display text-base font-bold uppercase tracking-wider text-brand-dark">Fleksibel planlægning</h3>
              <p className="mt-3 text-xs font-light leading-relaxed text-slate-500">
                Vi planlægger arbejdet, så det forstyrrer jeres daglige drift mindst muligt – f.eks. tidligt om morgenen eller uden for åbningstid.
              </p>
            </div>
            <div className="rounded-none border border-slate-200 bg-white p-8 shadow-none">
              <div className="flex h-10 w-10 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue">
                <i className="fa-solid fa-shield-halved" />
              </div>
              <h3 className="mt-6 font-display text-base font-bold uppercase tracking-wider text-brand-dark">Grundig & pålidelig</h3>
              <p className="mt-3 text-xs font-light leading-relaxed text-slate-500">
                Vi overholder altid vores aftaler og leverer et ensartet, fejlfrit resultat af højeste faglige standard hver eneste gang.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Galleri Sektion (Tilkoblet via slug) */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <GallerySection slug="erhvervs-vinduespolering" />
        </div>
      </section>
    </>
  );
}
